/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tags"
  }, _vm._l(_vm.list, function (item) {
    return _c('div', {
      staticClass: "tag",
      style: {
        color: item.color_rgb,
        border: "1px solid " + _vm.hexToRgba(item.color_rgb, 0.15),
        'box-shadow': "1px 1px 2px " + _vm.hexToRgba(item.color_rgb, 0.15),
        margin: "0 " + _vm.lrmargin + "rem " + _vm.tbmargin + "rem 0"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " "), _vm.showRemove ? _c('div', {
      on: {
        "click": function ($event) {
          return _vm.removeTag(item.id);
        }
      }
    }, [_c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-close-empty",
      attrs: {
        "type": "ios-close-empty",
        "size": "20",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "20",
        "height": "20",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      staticClass: "st0",
      attrs: {
        "d": "M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"
      }
    })])]) : _vm._e()]);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };